export default "__VITE_ASSET__CxkDZbFK__"